import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { PlayPage } from '../play/play';
import { HomePage } from '../home/home';
import { ReadstoryPage } from '../readstory/readstory';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { VersusAIPage } from '../versusai/versusai';
import { VersusPVPAsyncPage } from '../versuspvpasync/versuspvpasync';
import { VersusPVPsyncPage } from '../versuspvpsync/versuspvpsync';

@Component({
  selector: 'page-endgame',
  templateUrl: 'endgame.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class EndgamePage {
  mood:string;
  scorePartial:number;
  timeFinal:number;
  scoreFinalBonuses:number;
  language:number;
  typeOfwin="";
  statusPVPAsync:string;
  statusPVPSync:string;
  chunkFinished:boolean;
  downEntropy:number;
  upEntropy:number;
  scoreFinalChallenger:number;
  timeFinalChallenger:number;
  entropyFinalChallenger: number;
  wasGameModeVersus: boolean;
  wasGameModeVersusPVPAsync: boolean;
  wasGameModeVersusPVPSync: boolean;

  constructor(public functions: Functions, public playModel: GameModel, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public translate: TranslateService, public navCtrl: NavController, public navParams: NavParams) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
      
    this.scorePartial=0;
    this.mood="superhappy";
  }
  
  goToPlay(){
    if (this.wasGameModeVersus) {
      this.functions.setGameModeVersus(true);
    }
    this.stopPlayMusicWhenLeaving("PlayPage");   
    this.navCtrl.popTo(PlayPage);  
  }

  goToMainMenu(){
    //this.navCtrl.popToRoot();
    //this.navCtrl.push(HomePage, {});
    this.navCtrl.setRoot(HomePage, {});
    this.stopPlayMusicWhenLeaving("HomePage");   
  }

  goToReadStory(){
    this.navCtrl.setRoot(ReadstoryPage, {});
    this.stopPlayMusicWhenLeaving("ReadstoryPage");   
  }

  goToGamemodePage(){
    if (this.wasGameModeVersus) {
      this.navCtrl.setRoot(VersusAIPage, {});
    }
    if (this.wasGameModeVersusPVPAsync) {
      this.navCtrl.setRoot(VersusPVPAsyncPage, {});
    }
    if (this.wasGameModeVersusPVPSync) {
      this.navCtrl.setRoot(VersusPVPsyncPage, {});
    }
    
    this.stopPlayMusicWhenLeaving("GamemodesPage"); 
  }
  
  stopPlayMusicWhenLeaving(pageToGo){
    if(this.chunkFinished){
      this.functions.stopBgMusic('game_youWin');
    }else{
      this.functions.stopBgMusic('game_youLost');
    }
    if (pageToGo=="HomePage" || pageToGo=="GamemodesPage" || pageToGo=="ReadstoryPage") {
      this.functions.startBgMusic('app_BgMusic');
    }
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillEnter(){
    //before the page in question becomes active
    document.getElementById('sideMenuButton').style.display='none';
    this.functions.changeShowSidemenuButtonTo(true);
    this.scorePartial = this.navParams.get('scorePartial'); 
    this.timeFinal = this.navParams.get('timeFinal'); 
    this.scoreFinalBonuses = this.navParams.get('scoreFinalBonuses'); 
    this.typeOfwin = this.navParams.get('typeOfwin'); 
    this.statusPVPAsync = this.navParams.get('statusPVPAsync');  
    this.statusPVPSync = this.navParams.get('statusPVPSync');  
    this.chunkFinished = this.navParams.get('chunkFinished'); 
    this.downEntropy = this.navParams.get('downEntropy'); 
    this.upEntropy = this.navParams.get('upEntropy'); 
    this.scoreFinalChallenger = this.navParams.get('scoreFinalChallenger'); 
    this.timeFinalChallenger = this.navParams.get('timeFinalChallenger'); 
    this.wasGameModeVersus = this.navParams.get('wasGameModeVersus'); 
    this.wasGameModeVersusPVPAsync = this.navParams.get('wasGameModeVersusPVPAsync'); 
    this.wasGameModeVersusPVPSync = this.navParams.get('wasGameModeVersusPVPSync'); 
    this.entropyFinalChallenger = this.navParams.get('entropyFinalChallenger'); 

    
    
    if(!this.wasGameModeVersus && !this.wasGameModeVersusPVPAsync && !this.wasGameModeVersusPVPSync){
      if (this.chunkFinished) {
        this.mood="superhappy";
        this.functions.startBgMusic('game_youWin');
      }else{
        this.mood="supersad";
        this.functions.startBgMusic('game_youLost');
      }
    }else{
      if (this.typeOfwin=="win_versus") {
        this.mood="superhappy";
        this.functions.startBgMusic('game_youWin');
      }
      if(this.typeOfwin=="lost_versus"){
        this.mood="supersad";
        this.functions.startBgMusic('game_youLost');
      }
      if (this.typeOfwin=="versusPVPAsync" || this.typeOfwin=="versusPVPSync") {
        this.mood="superhappy";
        this.functions.startBgMusic('game_youWin');
      }
    }
    this.functions.getLanguage();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  ionViewWillLeave(){
    document.getElementById('sideMenuButton').style.display='block';
    console.log("Reload menu 2")
  } 
  
  /* --------- END IFECYCLE --------- */

}



// WEBPACK FOOTER //
// ./src/pages/endgame/endgame.ts